// Module
var code = "<div class=\"action-menu\"> <p class=\"heading\">Chart Options</p> <div class=\"contents\"> <ul> <li><a href=\"#\" @click.stop.prevent=\"duplicate()\" data-id=\"duplicate\">Duplicate</a></li> <li><a href=\"#\" @click.stop.prevent=\"deleteChart()\" data-id=\"delete-chart\">Delete Chart</a></li> </ul> </div> </div> ";
// Exports
export default code;